/**
 * Created with IntelliJ IDEA.
 * User: noam
 * Date: 1/14/14
 * Time: 5:33 PM
 * To change this template use File | Settings | File Templates.
 */
define(function (require) {
    "use strict";

    var LE = require("app");
    var Button = require("ui/button/Button");
    var Paging = require("ui/paging/Paging");
    var template = require("content-templates/content-edit/canned/contentCannedEditLayout.tmpl");
    var DropdownMenu = require("ui/dropdown-menu/DropdownMenu");


    var ContentCannedEditLayout = {};
    LE.module("LEContent", function (LEContent, LE, Backbone, Marionette, $, _) {

        ContentCannedEditLayout = Marionette.Layout.extend({
            template: template,
            className: "content-edit",
            regions: {
                leftPane: ".left-pane"
            },
            events: {
                "click .closeBtn": "_cancel"
            },
            ui: {
                actionsAreaWrapper:  ".page-actions-container",
                actionMenuContainer: ".actions-container",
                footerContainer:  ".page-footer",
                pagingContainer:  ".paging-container",
                mainArea:         ".view-container",
                cancelButton:     ".button-cancel",
                saveButton:       ".button-save",
                saveAndAddNewBtn: ".button-save-and-add"
            },
            uiComponents: {
                actionMenu: {
                    type: DropdownMenu,
                    options: {
                        el: "view.ui.actionMenuContainer",
                        name: LE.translator.translate("LEFramework.global.captions.action"),
                        collection: "view._getActionsCollection",
                        tabindex: "3",
                        align: DropdownMenu.ALIGN.RIGHT
                    },
                    events: {
                        "change":"_onActionSelected"
                    }
                },
                cancelBtn: {
                    type: Button,
                    options: {
                        el: "view.ui.cancelButton",
                        permutation: Button.PERMUTATION.LINK
                    },
                    events: {
                        "click": "_cancel"
                    }
                },
                paging: {
                    type: Paging,
                    options: {
                        el: "view.ui.pagingContainer",
                        blockWrongPageNumber: true,
                        pageType: Paging.PAGE_TYPE.ITEM
                    },
                    events: {
                        "change:page": "_changePage"
                    }
                },
                saveAndAddNewBtn: {
                    type: Button,
                    options: {
                        el: "view.ui.saveAndAddNewBtn",
                        permutation: Button.PERMUTATION.BTN,
                        initState:"view._getSaveButtonState",
                        tooltip:  "view._getSaveButtonTooltip"
                    },
                    events: {
                        "click": "_saveAndAddAnother"
                    }
                },

                saveBtn: {
                    type: Button,
                    options: {
                        el: "view.ui.saveButton",
                        permutation: Button.PERMUTATION.BTN_PRIMARY,
                        initState:"view._getSaveButtonState",
                        tooltip:  "view._getSaveButtonTooltip",
                        tooltipAlign: Button.TOOLTIP_ALIGN.RIGHT
                    },
                    events: {
                        "click": "_save"
                    }
                }
            },

            initialize: function (options) {
                LEContent.logger.debug("initialize ContentCannedEditLayout", "ContentCannedEditLayout:initialize");
                this.channel = options.channel;
                this.listenTo(this.model,"change:model",this._onModelChanged);
                this.listenTo(this.model,"change:save.allowed",this._toggleSaveBtn);
                this.listenTo(this.model,"change:save.tooltip",this._toggleSaveBtnTooltip);
                this.listenTo(this.model,"change:pageInfo.*",this._updatePagingComponent);
            },
            onRender: function () {
                LEContent.logger.debug("onRender ContentCannedEditLayout", "ContentCannedEditLayout:onRender");
                this.listenTo(this, "page:closeButtonClick", this._closeWindowButtonClicked);
                this._onModelChanged();
            },
            _getActionsCollection: function() {
                return new DropdownMenu.Collection([
                    {
                        id:"restoreToDefaults",
                        "actionName":LE.translator.translate("LEContent.content.edit.editor.restore.defaults.confirm.button"),
                        "title": LE.translator.translate("LEContent.content.edit.editor.restore.defaults.tooltip"),
                        "align": "right",
                        "enabled":true
                    }
                ]);
            },
            _onModelChanged: function () {
                //show the correct buttons for new/edit mode
                var isNew = this.model.getIsContentNew();
                this.ui.footerContainer.toggleClass("new-mode", isNew);
                //move back the scroller of the page to top
                this.ui.mainArea.scrollTop(0);

                //show hide the actions menu for messages that have defaults
                this.ui.actionsAreaWrapper.toggleClass("hide",!this.model.hasRestoreToDefault());
            },
            _getSaveButtonState : function () {
                return this.model.getIsSaveAllowed() ? Button.STATES.ENABLED : Button.STATES.DISABLED;
            },
            _getSaveButtonTooltip : function () {
                var tooltip = this.model.getIsSaveAllowedTooltipKey();
                return _.isString(tooltip) && tooltip.length > 0?LE.translator.translate(tooltip):"";
            },
            //---------------------------------------------------
            // Toggle save button to enable / disable according to required values for save of canned models
            //---------------------------------------------------
            _toggleSaveBtn:function () {
                this.uiComponents.saveBtn.setState(this._getSaveButtonState());
                this.uiComponents.saveAndAddNewBtn.setState(this._getSaveButtonState());
            },
            _toggleSaveBtnTooltip:function () {
                this.uiComponents.saveBtn.setTooltip(this._getSaveButtonTooltip());
                this.uiComponents.saveAndAddNewBtn.setTooltip(this._getSaveButtonTooltip());
            },

            _updatePagingComponent: function(){
                this.uiComponents.paging.setInfo(this.model.getContentPageInfoCurrentPage()+1,this.model.getContentPageInfoTotal());
            },

            /**
             * Handles the selected action
             * @param id
             */
            _onActionSelected: function(componentId, eventName, id){
                LEContent.logger.info("Content Edit: user clicked on menu action: " + id, "ContentCannedEditLayout:onActionSelected");
                switch (id) {
                    case "restoreToDefaults":
                        this.channel.trigger("contentCannedEditLayout:actions:restoreToDefaults");
                        break;
                    default:
                        LEContent.logger.graph({name: "content:ContentCannedEditLayout:_onActionSelected:idNotFound"});
                        LEContent.logger.error("Missing action handler for '" + id + "'","ContentCannedEditLayout:onActionSelected");
                        break;
                }
            },

            _cancel: function () {
                LEContent.logger.info("User clicked on 'Cancel' button.", "ContentCannedEditLayout::_cancel");
                this.channel.trigger("contentCannedEditLayout:cancel");
            },
            _closeWindowButtonClicked: function () {
                LEContent.logger.info("User clicked on 'close' button.", "ContentCannedEditLayout::_closeWindowButtonClicked");
                this.channel.trigger("contentCannedEditLayout:closeWindow");
            },

            _changePage: function (component,event,idx) {
                idx = idx -1; //update idx to use correct array indexing
                LEContent.logger.info("User asks to change page to " + idx, "ContentCannedEditLayout::_changePage");
                this.channel.trigger("contentCannedEditLayout:changePage",idx);
            },
            _saveAndAddAnother: function () {
                LEContent.logger.info("User clicked on 'saveAndAddAnother' button.", "ContentCannedEditLayout::_saveAndAddAnother");
                this.channel.trigger("contentCannedEditLayout:saveAndAddAnother");
            },

            _save: function () {
                LEContent.logger.info("User clicked on 'Save' button.", "ContentCannedEditLayout::_save");
                this.channel.trigger("contentCannedEditLayout:save");
            },

            onClose: function () {
                LEContent.logger.debug("content layout onClose", "ContentCannedEditLayout::onClose");
            },

            //check for view errors in the inner components
            validateView: function() {
                if (_.isFunction(this.leftPane.currentView.validateView)) {
                    return this.leftPane.currentView.validateView();
                }
                else{
                    return 0;
                }
            }
        });

    });
    return ContentCannedEditLayout;
});
